import { ClipboardArrowDownOutlineIcon } from './ClipboardArrowDownOutlineIcon';

/**
 * author: Google
 * id 0FB11B14-8890-432D-A4B0-7D359DE681D8
 * name clipboard-arrow-down-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-arrow-down-outline.svg
 * tags
 */
export const ClipboardArrowBottomOutlineIcon = ClipboardArrowDownOutlineIcon;
export default ClipboardArrowBottomOutlineIcon